import { IRecord, IRecordType } from 'annotation-tools/utils';
import { TrainingStatus } from '../enum/training-status';

// immutable object generator
export const ITrainingInfo = IRecord<TrainingInfoType>({
  trainingId: 0,
  status: 'created',
  rank: 1,
  name: '',
  uid: '',
  dateStarted: Date.now(),
  dateFinished: Date.now(),
  dateCreated: Date.now()
});

// immutable type
export type ITrainingInfoType = IRecordType<TrainingInfoType>;

type TrainingInfoType = {
  trainingId: number;
  status: TrainingStatus;
  rank: 1 | 2 | 3 | 4 | 5;
  name: string;
  uid: string; // システム内部で使用、フロント側では使用しない
  dateStarted: number;
  dateFinished: number;
  dateCreated: number;
};
